module.exports = __webpack_public_path__ + "static/media/55_000002.acd138ff.jpg";